import { baseApi } from '@/services'
import { ApplicationGuidelines, ApplicationOffer } from '@/types/unlock'
import { ApplicationCalcs } from '@/types/unlock'

export const applicationCalcsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getApplicationOffers: builder.query<ApplicationOffer, string>({
      query: (applicationUUID) =>
        `v2/applications/${applicationUUID}/calcs/?fields=max_offer,selected_offer,requested_offer`,
      providesTags: ['ApplicationOffer'],
    }),
    getApplicationGuidelines: builder.query<ApplicationGuidelines, string>({
      query: (applicationUUID) =>
        `v2/applications/${applicationUUID}/calcs/?fields=exchange_rate_guideline,annualized_cost_limit_guideline,max_investment_guideline`,
      providesTags: ['ApplicationGuidelines'],
    }),
    getApplicationMonthlyIncome: builder.query<any, string>({
      query: (applicationUUID) => `v2/applications/${applicationUUID}/calcs/?fields=monthly_income`,
      providesTags: ['ApplicationMonthlyIncome'],
    }),
    getApplicationCalcs: builder.query<ApplicationCalcs, string>({
      query: (applicationUUID) => `v2/applications/${applicationUUID}/calcs/`,
      providesTags: ['ApplicationCalcs'],
    }),
  }),
})
export const {
  useGetApplicationOffersQuery,
  useGetApplicationGuidelinesQuery,
  useGetApplicationMonthlyIncomeQuery,
  useGetApplicationCalcsQuery,
  useLazyGetApplicationCalcsQuery,
} = applicationCalcsApi
